/** @format */

import React from "react";
import { useLocation } from "react-router-dom";
import "../Style/Header.css";

function Header({ submittedEmail, onLogout }) {
  const location = useLocation();

  return (
    <header className='header'>
      <div className='header-left'>
        <img src='metlen_logo.png' alt='Metlen Logo' className='logo-img' />
      </div>
      <div className='header-right'>
        <span className='header-user'>Analytics Dashboard</span>
        {submittedEmail && location.pathname !== "/clients" && (
          <button onClick={onLogout} className='logout-button'>
            Logout
          </button>
        )}
      </div>
    </header>
  );
}

export default Header;
